import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import SendIcon from '@mui/icons-material/Send';
import { collection, query, where, getDocs ,getFirestore } from "firebase/firestore";





const EmailDashBoard = () => {
      const[email, setEmail] = useState({
        title: '',
        description:'',       
    });
    const [allContact, setAllContact] = useState([]);
    const [contactToSend, setContactToSend] = useState(null);
 
const db = getFirestore()
const getData = async () => {

let dataArray = []
const q = query(collection(db, "emails"));
const querySnapshot = await getDocs(q);
querySnapshot.forEach((doc) => {

    dataArray.push(doc.data().email)

})

setAllContact(dataArray)
}

    
    
    useEffect(()=>{

        getData()
        setContactToSend('mailto:' + allContact.join(';') + '?subject='+email.title+'&body='+email.description)
       

    },[email])
    
    const handleChange = (e) => {
        if(e.target.name === 'title'){
            setEmail({...email, title: e.target.value})
        }
        
        if(e.target.name === 'description'){
            setEmail({...email, description: e.target.value})
        }
    }

    
    
  
    

    return (
        <Container>

            <div className="content">
                <form >
                    <label htmlFor="title">Objet</label>
                    <input maxLength={80} className="input" type="text" name="title" id="title" onChange={handleChange} value={email.title} />
                    <label htmlFor="description">Ecrivez votre Email</label>
                    <textarea onChange={handleChange} value={email.description} className='area' name="description" id="description" cols={30} rows={10} maxLength={250} placeholder='Description'></textarea>
                    
                    <div className="footer mail">
                      {contactToSend !== null && email.title !== '' ? <a href={contactToSend}>Envoyer à tous les contacts <SendIcon/>   </a> : <button disabled>Corps du texte vide</button>}
                            

                    </div>
                  
                </form>
            </div>    
        </Container>
    );


};

const Container = styled.div`
height: 100%;
width: 100%;
display: flex;
flex-direction: column;
justify-content: center;
align-items: center;

.content{
    width: 100%;
    height: 100%;
   
    display:flex;
    justify-content: center;
    align-items: center;

    form{
    position: relative;
    top: 100px;
    
    width: 92%;
    height: 100%;
    display:flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items:flex-start;
    gap: 12px;

    

   

    
    
}





    
}
`


export default EmailDashBoard;